import { makeStyles } from '@material-ui/core/styles';
import MuiTableCell, { TableCellProps as MuiTableCellProps } from '@material-ui/core/TableCell';
import React from 'react';

export interface TableCellProps extends MuiTableCellProps {
  width?: number;
}

const useStyles = makeStyles(theme => ({
  alignRight: {
    flexDirection: 'unset',
  },
  head: {
    backgroundColor: theme.palette.common.gray100,
    lineHeight: 'unset',
    padding: theme.spacing(1.5, 1),
  },
  root: {
    maxWidth: ({ width }: TableCellProps) => width,
    minWidth: ({ width }: TableCellProps) => width,
  },
}));

/**
 * @deprecated
 * @example
 *
 * This is fine to use, however we'd prefer to set the styles of this via
 * the theme and consume MuiTableCell
 * ```
 * <MuiTableCell component="th" scope="row">Calories</MuiTableCell>
 * <MuiTableCell align="right">Calories</MuiTableCell>
 * ```
 */

export const TableCell: React.FC<TableCellProps> = ({ width, ...props }) => {
  const classes = useStyles({ width });
  return <MuiTableCell classes={classes} {...props} />;
};

export default TableCell;
